import { Injectable } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { ConfirmationModalComponent } from "src/app/application/confirmation-modal/confirmation-modal.component";
import { ErrorTranslateService } from "./error-translate.service";

@Injectable({ providedIn: "root" })
export class ConfirmationModalService {
  constructor(
    public modalService: NgbModal,
    private translate: TranslateService,
    private errorTranslateService: ErrorTranslateService
  ) {}

  /**
   * Opens a confirmation modal with the given title and message.
   * @param titleKey The translation key for the title.
   * @param messageKeyOrKeys The translation key(s) for the message. 
   *                         Can be an array of keys,
   *                         a single key as string,
   *                         or string of keys seperated by "; "
   * @param error Whether the modal is for an error (default: false).
   * @returns A promise that resolves when the modal is closed.
   */
  openConfirmationModal(
    titleKey: string,
    messageKeyOrKeys: string | string[],
    error: boolean = false
  ) {
    const modalRef = this.modalService.open(ConfirmationModalComponent);
    modalRef.componentInstance.title = this.translate.instant(titleKey);
    if (Array.isArray(messageKeyOrKeys)) {
      modalRef.componentInstance.messages = messageKeyOrKeys.map(key =>
        this.translate.instant(key)
      );
    } else {
      modalRef.componentInstance.messages = this.errorTranslateService.translateErrorMessageKeys(messageKeyOrKeys);
    }
    modalRef.componentInstance.error = error;

    return modalRef.result;
  }
}
